import {
  FILTER_KEYS,
  parseNumberFilter,
  parseTextFilter,
  toFilterText,
  toGeoFilterValues,
  toGeoSearch,
} from '@/utils/filters';
import type { SurveySubmissionFilters } from '../types/survey.types';

type FilterValues = Record<string, string>;

export function toSurveySubmissionFilterValues(search: SurveySubmissionFilters): FilterValues {
  return {
    [FILTER_KEYS.departmentId]: toFilterText(search.departmentId),
    ...toGeoFilterValues(search),
    userName: toFilterText(search.userName),
    userHrId: toFilterText(search.userHrId),
    contactNumber: toFilterText(search.contactNumber),
  };
}

export function toSurveySubmissionFilterSearch(values: FilterValues): SurveySubmissionFilters {
  return {
    departmentId: parseNumberFilter(values[FILTER_KEYS.departmentId]),
    ...toGeoSearch(values),
    userName: parseTextFilter(values.userName),
    userHrId: parseTextFilter(values.userHrId),
    contactNumber: parseTextFilter(values.contactNumber),
  };
}
